<template>
  <div class="frequency-modal__time">
    <input-field
      input="MdsInput"
      type="time"
      label="Time"
      :value="time"
      :validator-function="validTime"
      :revalidate="[repeatType, startDate, timezone]"
      :min="minimum"
      @input="$emit('input', { runningTime: $event })"
      @error="$emit('error', $event)"
    />
    <mds-combo-box
      label="Time Zone"
      :data-set="timezoneDataSet"
      :selected-items="[selectedTimezone]"
      @input="setSelectedTimezone($event)"
    />
  </div>
</template>

<script>
import MdsComboBox from '@mds/combo-box'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import InputField from '@/components/frequencyModal/frequencies/helpers/InputField'
import defaultConfig from '@/components/frequencyModal/config/i18n'
import moment from 'moment-timezone'

export default {
  name: 'TimePeriod',
  components: {
    InputField,
    MdsComboBox,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    time: {
      type: String,
      default: '',
    },
    timezone: {
      type: String,
      default: '',
    },
    isSameDay: Boolean,
    repeatType: {
      type: String,
      default: '',
    },
    startDate: {
      type: String,
      default: '',
    },
    timezones: {
      type: Function,
      default: () => [],
    },
  },
  data() {
    return {
      defaultConfig,
      selectedTime: '',
      selectedTimezone: 'America/Chicago',
      timezoneDataSet: [],
      minimumDateTime: 0.0,
    }
  },
  watch: {
    selectedTimezone() {
      if (this.selectedTimezone) {
        this.$emit('input', { timezone: this.selectedTimezone })
      }
    },
  },
  created() {
    this.onLoadTimezones()
    this.minimum()
  },
  methods: {
    validTime(timeUser) {
      if (timeUser && typeof timeUser === 'string') {
        this.selectedTime = timeUser
      }
      const [hours, minutes] = timeUser.split(':')
      const [year, month, day] = this.startDate.split('-')
      const currentDateWithOffset = new Date(
        `${year}-${month}-${day} ${parseInt(hours)}:${parseInt(minutes)}:00`
      ).valueOf()
      this.minimum()
      if (
        moment
          .unix(currentDateWithOffset)
          .isBefore(moment.unix(this.minimumDateTime))
      ) {
        const error = new Error(this.translate('frequency.modal.time.error'))
        error.name = ''
        throw error
      }
    },
    onLoadTimezones() {
      this.timezoneDataSet = this.timezones()
      this.selectedTimezone = this.timezone
      this.$emit('input', { timezone: this.selectedTimezone })
    },
    minimum() {
      const currentDate = moment()
        .tz(this.selectedTimezone)
        .add('10', 'minutes')
      const hours = currentDate.hours()
      const minutes =
        (currentDate.minutes() < 10 ? '0' : '') +
        currentDate.minutes().toString()

      this.minimumDateTime = Date.parse(
        currentDate.format('YYYY-MM-DD HH:mm:ss')
      )
      return hours + ':' + minutes
    },
    setSelectedTimezone(event) {
      this.selectedTimezone = event[0]
    },
  },
}
</script>

<style lang="scss" scoped>
.frequency-modal__time {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
